import React, { useState, useEffect } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { CgSpinner } from "react-icons/cg";
import AjeerFeeUpdate from "./AjeerFeeUpdate/AjeerFeeUpdate";
import { useDispatch, useSelector } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { useNavigate } from "react-router-dom";

export default function FinListAjeer({ titles = [], list = [], updateData }) {
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const maxSelected = 25;
  const dispatch = useDispatch();

  // navigation screen
  const navigate = useNavigate();

  const [newCurrentList, setNewCurrentList] = useState([]);
  var appliedTilteList = [
    "SR.NO.",
    "VISA PROVIDER",
    "CLIENT NAME",
    "Employee COUNT",
    "SPONSOR ID 700",
    "status",
  ];
  const { NoDataFoundData, firestList } = useSearchPagination(list || []);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(newCurrentList || []);
  console.log("........currentList....", list, firestList);
  const [indexValue, setIndex] = useState(10);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [Popup, setPopUp] = React.useState(false);

  const handleCheckboxChange = (event, emp_id) => {
    const isChecked = event.target.checked;
    const totalChecked = Object.values(checkedItems).filter(Boolean).length;
    // If maximum checkboxes are already selected and current checkbox is being checked, prevent further selection
    if (isChecked && totalChecked >= maxSelected) {
      dispatch(
        setAppError({
          msg: "Maximum candidate selection limit reached",
        })
      );
      return;
    }

    setCheckedItems((prevState) => ({
      ...prevState,
      [emp_id]: isChecked,
    }));
  };

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };

  // const updateData = () => {
  //   // navigate(`/dashboard/gr-ajeer/`);
  // };

  console.log("My clock to be seen here")

  return (
    <>
      <div className="relative bg-white m-2">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 min-w-[1000px]">
            <div className="grid grid-cols-table-ajeer-applied gap-5 p-6 text-center">
              {appliedTilteList.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div>
            {firestList?.isLoading && (
              <LoadingWithLable className="col-span-6" />
            )}
            {firestList?.isLoading && <NoDataFoundData />}
            {!firestList?.isLoading
              ? list?.data?.listData.map((listData, index) => (
                <a
                  key={index}
                  onClick={() => {
                    const filteredData = list?.data?.data.filter(
                      (indexData) =>
                        indexData.visa_provider === listData.visa_provider &&
                        indexData.client_name === listData.client_name &&
                        indexData.ajeer_status === listData.ajeer_status
                    );
                    setNewCurrentList(filteredData);
                    setIndex(index);
                  }}
                  className={`grid grid-cols-table-ajeer-applied auto-cols-min gap-5 p-4 text-center ${indexValue === index ? "bg-orange-50" : "bg-white"} rounded-md `}
                  style={{ cursor: "pointer" }} // Apply pointer cursor style
                >
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.visa_provider || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.client_name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={
                          listData.employee_count.toString() || "-"
                        }
                      />
                    </p>
                    <p className="overflow-x-hidden">
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.sponsor_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.ajeer_status || "-"}
                      />
                    </p>
                  </React.Fragment>
                </a>
              ))
              : ""}
          </div>
        </div>
      </div>
      {currentList.length !== 0 ? (
        <>
          <div className="flex flex-wrap  gap-2 w-full items-center flex flex-row-reverse space-x-reverse">
            <Search
              searchKey={[
                "employee_id",
                "name",
                "client_name",
                "iqama_number",
                "visa_provider"
              ]}
              setSearchWords={setSearchWords}
            />

            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => popOpen()}
              // disabled={downloadLoading || list?.isLoading}
            >
              <p>Update</p>
              {downloadLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
          <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
          <CountPerPage />
          <div className="relative bg-white">
            <div className="overflow-x-auto max-h-[70vh] ">
              <div className="sticky top-0 z-10 bg-white min-w-[2550px]">
                <div className="grid grid-cols-table-ajeer-update gap-5 p-6 text-center">
                  {titles.map((t, index) => (
                    <p key={index} className="font-semibold uppercase">
                      {t == "ACTION" ? <div className="flex items-center mb-0  ">
                        <input
                          // disabled={list.ajeer_status_value.toString() === "2" || list.ajeer_status_value.toString() === "5" ? false : true}
                          key={list.employee_id}
                          type="checkbox"
                          checked={checkedItems[currentList.map((e) => (e.employee_id))] || false}
                          onChange={(event) => {
                            currentList.map((list) => (handleCheckboxChange(event, list.employee_id)));
                          }
                          }
                        />
                      </div> : t}
                    </p>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-table-ajeer-update gap-5 p-6 bg-white text-center">
                {list?.isLoading && (
                  <LoadingWithLable className="col-span-full" />
                )}
                {!list?.isLoading && <NoDataFound />}
                {!list?.isLoading &&
                  currentList.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>

                      <p className="overflow-x-hidden">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.client_name || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_provider || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.iqama_number || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_location_eng || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_location_ar || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_apply_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_issue_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_expiry_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_valid_days || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.ajeer_status || "-"}
                        />
                      </p>
                      <div className="flex items-center mb-0  ">
                        <input
                          disabled={
                            list.ajeer_status === "Request Accepted By Client"
                              ? true
                              : false
                          }
                          key={list.employee_id}
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id)
                          }
                        />
                      </div>
                      <hr
                        className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>

          <Pagination />
        </>
      ) : (
        <></>
      )}

      {Popup ? (
        <AjeerFeeUpdate
          list={Object.entries(checkedItems)
            .filter(([emp_id, isChecked]) => isChecked)
            .map(([emp_id]) => emp_id)}
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Update Ajeer Fee"}
          url={"/ajeer/updateFees/"}
          apiCall={updateData}
        />
      ) : (
        ""
      )}
    </>
  );
}
